import type { ScheduleForecastState } from "../../domain/weather";
import type { TeamAppModel } from "../../hooks/teamTypes";
import { SetupScreen } from "../setup/SetupScreen";

interface SetupRouteProps {
  model: TeamAppModel;
  weatherState?: ScheduleForecastState;
  onRetryWeather: () => void;
  weatherRefreshing?: boolean;
}

export function SetupRoute({
  model,
  weatherState,
  onRetryWeather,
  weatherRefreshing = false,
}: SetupRouteProps) {
  const { shell, setup } = model;

  return (
    <SetupScreen
      toast={null}
      hasActiveGame={setup.game !== null}
      manageOpen={shell.manageOpen}
      managementPanel={null}
      players={setup.players}
      activePlayerIds={setup.activeIds}
      lineupSlots={setup.lineupSlots}
      lineupMode={setup.lineupMode}
      preferences={setup.preferences}
      expandedPlayerId={setup.expandedPlayerId}
      confirmDeletePlayerId={setup.confirmDeletePlayerId}
      jerseyHolderPlayerId={setup.jerseyHolderPlayerId}
      opponentName={setup.opponentName}
      opponentLocked={setup.opponentLocked}
      isHome={setup.isHome}
      authoritativeRevision={setup.authoritativeRevision}
      scheduledDate={setup.scheduledDate}
      timeSlot={setup.timeSlot}
      field={setup.field}
      beerDuty={setup.beerDuty}
      battingCount={setup.battingCount}
      serverBusy={setup.serverBusy}
      actionStatus={setup.actionStatus}
      onShowGame={() => shell.setScreen("game")}
      onToggleManage={() => shell.setManageOpen((open) => !open)}
      onSetAttendance={setup.actions.setAttendance}
      onTogglePlayerExpanded={(playerId) => {
        setup.setExpandedPlayerId(
          setup.expandedPlayerId === playerId ? null : playerId,
        );
        setup.setConfirmDeletePlayerId(null);
      }}
      onTogglePreference={setup.actions.togglePref}
      onSetJerseyHolder={setup.actions.setJerseyHolder}
      onRequestPlayerRemoval={setup.setConfirmDeletePlayerId}
      onConfirmPlayerRemoval={async (playerId) => {
        const succeeded = await setup.actions.removePlayer(playerId);
        if (succeeded) {
          setup.setConfirmDeletePlayerId(null);
          setup.setExpandedPlayerId(null);
        }
        return succeeded;
      }}
      onCancelPlayerRemoval={() => setup.setConfirmDeletePlayerId(null)}
      onSuggestLineup={setup.actions.suggestLineup}
      onCommitLineup={setup.actions.reorderLineup}
      onSetOpponentName={setup.actions.setOpponentName}
      onSetHomeTeam={setup.actions.setHomeTeam}
      onSetScheduleDetails={setup.actions.setScheduleDetails}
      onShowDefense={() => shell.setScreen("defense")}
      onStartGame={setup.actions.startGame}
      {...(weatherState ? { weatherState } : {})}
      onRetryWeather={onRetryWeather}
      weatherRefreshing={weatherRefreshing}
    />
  );
}
